/**
 * Etat du compte, cote client.
 *
 * IMPORTANT : ce store ne fait AUCUNE authentification. Il tient ce que
 * l'interface doit afficher, et delegue au serveur par `net/account.ts`. Tant
 * que le socle serveur n'existe pas, `signIn` et consorts echouent franchement
 * plutot que de simuler une session : un faux « connecte » cache exactement le
 * bug qu'on cherchera ensuite.
 *
 * L'avatar et le pseudo, eux, sont deja des preferences locales utiles sans
 * compte : ils vivent dans `uiStore` et le compte ne fera que les synchroniser.
 */
import { create } from 'zustand';

export interface AccountProfile {
  readonly id: string;
  readonly email: string;
  /** Vrai une fois l'adresse verifiee. Sans quoi l'achat restera ferme. */
  readonly emailVerified: boolean;
  readonly nickname: string | null;
  readonly avatar: string | null;
  /** Achat unique effectue : seul un compte paye porte un avatar payant. */
  readonly paid: boolean;
}

export type AccountStatus = 'anonymous' | 'loading' | 'signedIn';

interface AccountState {
  status: AccountStatus;
  profile: AccountProfile | null;
  /** Derniere erreur serveur, deja traduite par l'appelant. */
  error: string | null;
  setStatus(status: AccountStatus): void;
  setProfile(profile: AccountProfile | null): void;
  setError(error: string | null): void;
}

export const useAccountStore = create<AccountState>()((set) => ({
  status: 'anonymous',
  profile: null,
  error: null,
  setStatus: (status) => set({ status }),
  setProfile: (profile) => set({ profile, status: profile === null ? 'anonymous' : 'signedIn' }),
  setError: (error) => set({ error }),
}));
